import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import IssuesStatusChart from "./IssuesStatusChart";
import moment from "moment";

const dummyTopics = [
  {
    id: 1,
    user: "",
    title: "The picture is not displaying properly",
    feedback: "The Yi Home Mobile app is unable to pair with the camera",
    isAdmin: false,
  },
  {
    id: 2,
    user: "",
    title: "Unable to display video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 3,
    user: "",
    title: "The images are not playing in my video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
];

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function ChatBotKBEffiencyGraph(props: any) {
  const {
    preAIFeedbackGraphData,
    kbFeedbackGraphData,
    startDateValue,
    endDateValue,
  } = props;

  const [filtertype, setFiltertype] = React.useState("weekly");
  const [RespType, setRespType] = React.useState("AIResp");

  const navigate = useNavigate();

  const handleRedirectUncategorisedTickets = () => {
    const stateObj = {
      pageType: "mainReportPage",
    };
    navigate(`/view-uncategorized-ticket`, { state: stateObj });
  };

  const handleInputChange = (value: any) => {
    setFiltertype(value);
  };

  const handleRestTypeClick = (type: string) => {
    setRespType(type);
  };

  return (
    <Grid
      item
      sx={{ border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}
    >
      <Typography className="block-header-sec">
        <Grid
          container
          alignItems="center"
          // spacing={1}
          // sx={{ justifyContent: "space-between" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={4} xl={5}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "13px",
                textTransform: "uppercase",
              }}
            >
              KNOWLEDGE BASE EFFICIENCY
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={3} xl={2}>
            <Button
              variant="contained"
              sx={{
                fontSize: "10px",
                padding: "5px 10px 5px 10px",
                borderRadius: "15px",
                boxShadow: "none",
                border: `1px solid ${
                  RespType == "AIResp" ? "#fff" : "#2858D3"
                }`,
                color: RespType == "AIResp" ? "#fff" : "#2858D3",
                background: RespType == "AIResp" ? "#2858D3" : "#fff",
              }}
              onClick={() => handleRestTypeClick("AIResp")}
            >
              AI Response
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <Button
              variant="contained"
              sx={{
                fontSize: "10px",
                padding: "5px 10px 5px 10px",
                borderRadius: "15px",
                boxShadow: "none",
                border: `1px solid ${
                  RespType != "AIResp" ? "#fff" : "#2858D3"
                }`,
                color: RespType != "AIResp" ? "#fff" : "#2858D3",
                background: RespType != "AIResp" ? "#2858D3" : "#fff",
              }}
              onClick={() => handleRestTypeClick("preAIResp")}
            >
              Pre AI Response
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
            <FormControl className="custom-select gudieTourPlatform">
              <Select
                sx={{
                  boxShadow: "none",
                  ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                    {
                      border: 0,
                    },
                  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      border: 0,
                    },
                }}
                labelId="platform-select"
                id="platform-select"
                value={filtertype}
                label="platform"
                onChange={(e) => handleInputChange(e.target.value)}
              >
                <MenuItem key={1} value={"daily"}>
                  {"Daily"}
                </MenuItem>
                <MenuItem key={2} value={"weekly"}>
                  {"Weekly"}
                </MenuItem>
                <MenuItem key={3} value={"monthly"}>
                  {"Monthly"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Typography>
      <IssuesStatusChart
        filtertype={filtertype}
        startDateValue={moment(new Date(startDateValue), "DD-MM-YYYY").format(
          "DD/MM/YYYY"
        )}
        endDateValue={moment(new Date(endDateValue), "DD-MM-YYYY").format(
          "DD/MM/YYYY"
        )}
        ReportsTicketsTotalCountsData={
          RespType == "preAIResp" ? preAIFeedbackGraphData : kbFeedbackGraphData
        }
      />
    </Grid>
  );
}
